import { IPointZone } from 'js/bubbleCore/types';
import { ISpace } from 'framework/utils/math-utils';
import { RandomDataGenerator } from 'framework/RandomDataGenerator/RandomDataGenerator';
import { ILevelDataPointZone } from 'js/bubbleCore/levelParser/parseLevel';

export function generatePointZones(
  rnd: RandomDataGenerator,
  levelData: ILevelDataPointZone[],
  space: ISpace,
): IPointZone[] {
  const width = space.right - space.left;

  return levelData.map((zoneData, index) => {
    const nextZone = levelData[index + 1] || null;
    const nextZoneX = nextZone ? nextZone.x : 1;

    return {
      id: rnd.uuid(),
      rect: {
        x: space.left + zoneData.x * width,
        width: (nextZoneX - zoneData.x) * width,
        y: space.top,
        height: space.bottom,
      },
      score: zoneData.score,
    }
  });
}